module.exports = __webpack_public_path__ + "img/20.4.NH3-N.7fdcab9c.png";